'use client';

import { useEffect, useRef } from 'react';

import styles from './Video.module.scss';

interface Props {
  link: string;
  isVisible: boolean;
  linkWebm?: string;
  className?: string;
  preload?: 'auto' | 'metadata' | 'none';
}

export const Video = ({
  link,
  isVisible = true,
  linkWebm,
  className,
  preload = 'none',
}: Props) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const stopVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  useEffect(() => {
    if (videoRef) {
      if (isVisible) {
        videoRef.current?.play();
      } else {
        stopVideo();
      }
    }
  }, [isVisible]);

  return (
    <video
      ref={videoRef}
      className={className ?? styles.video}
      muted
      playsInline
      preload={preload}
    >
      <source src={linkWebm} type="video/webm" />
      <source src={link} type="video/mp4" />
    </video>
  );
};
